/**
 * Created by Rodrigo Quesada on 25/01/17.
 */
import {Component, forwardRef, HostBinding, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {noop} from '@angular/core/src/linker/view_utils';
import {ReplaySubject} from 'rxjs';

// region NG_VALUE_ACCESSOR
const MY_SELECTOR_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectorComponent),
    multi: true
};
// endregion

let nextUniqueId = 0;

// region Other Classes
export class Option {

    readonly label: string;

    constructor(readonly value: string, label?: string) {
        this.label = label !== undefined ? label : value;
    }
}

type Options = Option[];
// endregion

@Component({
    selector: 'my-selector',
    template: require('./selector.component.html'),
    styles: [require('./selector.component.scss')],
    providers: [MY_SELECTOR_CONTROL_VALUE_ACCESSOR]
})
export class SelectorComponent implements ControlValueAccessor {

    readonly id = `my-selector-${++nextUniqueId}`;

    // region Input
    @HostBinding('class') @Input() style?: 'admin';
    @Input() placeholder: string;
    @Input() name: string|null = null;
    @Input() errorMessage: String;
    @Input() errorMessagePosition: String = 'right';

    @Input() disabled: boolean = false;

    options$ = new ReplaySubject<Options>(1);

    @Input() set options(values: Options|string[]) {
        let options = (values as any[]).map(value => value instanceof Option ? value : new Option(value))
            .sort((a, b) => a.label.localeCompare(b.label));
        this.options$.next(options);
    }

    // endregion

    _value?: string;

    @Input() get value(): string|undefined|null { return this._value; }

    set value(value: string|undefined|null) {
        if (value === null) value = undefined;
        if (value !== this._value) {
            this._value = value;
            this._onChangeCallback(value);
        }
    }

    private focused: boolean = false;

    get empty() {
        return this._value === '' || this._value === undefined;
    }

    constructor() {
    }

    // region Events
    onFocus() {
        this.focused = true;
    }

    onBlur() {
        this.focused = false;
        this._onTouchedCallback();
    }

    // endregion

    // region ControlValueAccessor
    /** Callback registered via registerOnTouched (ControlValueAccessor) */
    private _onTouchedCallback: () => void = noop;
    /** Callback registered via registerOnChange (ControlValueAccessor) */
    private _onChangeCallback: (_: any) => void = noop;

    writeValue(value?: string): void {
        this._value = value;
    }

    registerOnChange(fn: any): void {
        this._onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouchedCallback = fn;
    }

    // endregion
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/selector/selector.component.ts